












import gql from 'graphql-tag'
import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppItemReview from '@/components/AppItemReview.vue'
import { Common, ScrollToFetch } from '@/mixins'

@Component({
  components: {
    AppItemReview
  },
  apollo: {
    itemReviewConnection: {
      query: gql`query itemReviewConnection($itemId: ID!, $first: Int, $after: String) {
        itemReviewConnection(filter: { itemId: $itemId }, first: $first, after: $after) {
          cursor
          hasNextPage
          reviews {
            id
            username
            rate
            createdAt
            t
            user {
              id
              username
              media {
                id
                path
              }
            }
            medias {
              id
              type
              path
            }
            orderItem {
              id
              itemVariantOption
            }
          }
        }
      }`,
      variables () { return { itemId: this.itemId, first: this.first } }
    }
  }
})
export default class extends Mixins(Common, ScrollToFetch) {
  @Prop(String) readonly itemId!: string
  @Prop(Number) readonly first!: number
  @Prop(String) readonly reviewId!: string
  itemReviewConnection = {}
  reviewIdExpanded: null | string = null

  mounted () {
    if (!this.first) {
      this.addScrollListener('itemReviewConnection', 'reviews')
    }
    this.reviewIdExpanded = this.reviewId
  }

  onClickReview (reviewId: string) {
    if (this.first) {
      this.$emit('click-review', reviewId)
    } else {
      this.reviewIdExpanded = this.reviewIdExpanded === reviewId ? null : reviewId
    }
  }
}
